import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { VITE_ENVIRONMENT } from './config';

Sentry.init({
  dsn: 'https://376d24acaaa2a6058819b9d53d396484@o463956.ingest.us.sentry.io/4507685571788800',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 100% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  environment: VITE_ENVIRONMENT,
});

void import('./instrumentReplay')
  .then(({ addReplay }) => addReplay())
  .catch((error) => {
    // Replay is optional, and an unhandled rejection here would be reported by Sentry's own
    // global handler.
    console.error(error);
  });
